import Compset from '@/components/Compset';
import { IN_APP_ROUTES } from '@/constants/urls';
import { useCompset } from '@/contexts/CompsetContext';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

function AddCompsetPage() {

    const { client, compHotels } = useCompset();

    if (compHotels.length <= 0 || !client) {
        return <Navigate
            to={IN_APP_ROUTES.DASHBOARD}
            replace={true}
        />
    }


    return (
        <div>
            <Compset
                mode={"edit"}
                competitorHotels={compHotels}
                clientHotel={client}
            />
        </div>
    );
}

export default AddCompsetPage;